import { useNuxtApp } from 'nuxt/app'
import type { MatomoClient } from '@packages/matomo'

const noopMatomoClient: MatomoClient = {
  getSiteId: () => '',
  init: () => {},
  isEnabled: () => false,
  matomofn: () => {},
  trackEvent: () => {},
  trackPageView: () => {},
}

export const useMatomo = (): MatomoClient => useNuxtApp().$matomo ?? noopMatomoClient
